<template>
    <div>
        <van-nav-bar
            title="购买VIP"
            left-text="返回"
            left-arrow
            @click-left="$router.replace({path:'/'})"
        />
        <div class="padding" v-if="chooseInfo">
            <div class="margin-top">
                <van-row gutter="10">
                    <van-col span="8" v-for="(item,index) in list" @click="choose(item)">
                        <div class="vip-price-item" :class="chooseInfo.id === item.id ? 'on' : ''">
                            <div class="f14">{{item.title}}</div>
                            <div class="f20 margin-top red">￥{{item.price}}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="f12 margin-top dark-3">VIP说明：</div>
            <div class="f14" v-html="chooseInfo.des" style="line-height: 24px;"></div>
            <div class="margin-top">
                <van-button block square type="info" @click="toPay">立即支付</van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return{
            list:[],
            chooseInfo:null
        }
    },
    mounted() {
        this.getList();
    },
    methods:{
        getList(){
            let _this = this;

            this.$http.post({
                url:'VipPrice/listAll',
                data:{state:1,orderBy:'sort',sortBy:'asc'},
                success(res){
                    console.log(res);
                    _this.list = res;

                    if(res.length > 0){
                        _this.chooseInfo = res[0];
                    }
                    // _this.info = res;
                    //this.$store.commit('reAddress',_d);
                }
            })
        },
        choose(item){
            this.chooseInfo = item;
        },
        toPay(){
            this.$router.push({path:'/order/pay/',query:{
                    id:this.chooseInfo.id,
                    title:this.chooseInfo.title,
                    order_type:'vip',
                    pay_amount:this.chooseInfo.price,
                    uid:this.$route.query.uid ? this.$route.query.uid : '',
                    url:this.$route.query.url ? this.$route.query.url : ''
                }})
        }
    }
}
</script>
